import { useState } from "react";
import { Link, useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { ArrowRight } from "lucide-react";
import Footer from "../components/Footer";

export default function Register() {
  const { register, user } = useAuth();
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  if (user && user.email) return <Navigate to="/" replace />;

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    const res = await register(email.trim(), password, name.trim(), companyName.trim());
    setLoading(false);
    if (res.ok) navigate("/");
    else setError(res.error);
  };

  return (
    <div className="min-h-screen flex flex-col bg-white">
      <div className="flex-1 flex items-center justify-center px-6 py-12">
      <div className="w-full max-w-md" data-testid="register-form">
        <div className="label-mini">new account</div>
        <h1 className="font-display text-4xl tracking-tight font-bold mt-2">Register your company</h1>
        <p className="text-sm text-neutral-500 mt-2">
          Each company has a private invoice ledger. You&apos;ll only see invoices your company sent or received.
        </p>

        <form className="mt-8 space-y-4" onSubmit={onSubmit}>
          <div>
            <label className="label-mini block mb-2" htmlFor="company">company name</label>
            <input
              id="company"
              type="text"
              className="input-field"
              placeholder="e.g. Acme Industrial Co."
              value={companyName}
              onChange={(e) => setCompanyName(e.target.value)}
              required
              data-testid="register-company-input"
            />
          </div>
          <div>
            <label className="label-mini block mb-2" htmlFor="name">your full name</label>
            <input
              id="name"
              type="text"
              className="input-field"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
              data-testid="register-name-input"
            />
          </div>
          <div>
            <label className="label-mini block mb-2" htmlFor="email">company email</label>
            <input
              id="email"
              type="email"
              className="input-field"
              placeholder="billing@yourcompany.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              data-testid="register-email-input"
            />
            <div className="text-xs text-neutral-500 mt-1">
              This is the email another company would address invoices to. We use it to auto-link incoming invoices.
            </div>
          </div>
          <div>
            <label className="label-mini block mb-2" htmlFor="password">password</label>
            <input
              id="password"
              type="password"
              className="input-field"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              minLength={6}
              data-testid="register-password-input"
            />
          </div>

          {error && (
            <div className="border border-red-600 text-red-600 text-xs px-3 py-2" data-testid="register-error">
              {error}
            </div>
          )}

          <button
            type="submit"
            className="btn-primary w-full flex items-center justify-center gap-2"
            disabled={loading}
            data-testid="register-submit-button"
          >
            {loading ? "creating…" : "create account"} <ArrowRight size={14} />
          </button>
        </form>

        <div className="mt-6 text-xs text-neutral-500">
          already have an account?{" "}
          <Link to="/login" className="underline text-neutral-900" data-testid="register-login-link">
            sign in
          </Link>
        </div>
      </div>
      </div>
      <Footer />
    </div>
  );
}
